import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import type { QuotedProductListItem } from "../../hooks/useGetQuotedProducts"
import { useQuotedProductColumns } from "../../hooks/useQuotedProductColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"

interface QuotedProductsTableProps {
  data: QuotedProductListItem[]
  isFetching: boolean
  error?: CombinedError
  containerRef: RefObject<HTMLDivElement>
  onScroll: () => void
  onAssociate: (product: QuotedProductListItem) => void
}

export const QuotedProductsTable: FC<QuotedProductsTableProps> = ({
  data,
  isFetching,
  error,
  containerRef,
  onScroll,
  onAssociate,
}) => {
  const columns = useQuotedProductColumns({ onAssociate })

  return (
    <AerosBaseTable
      error={error}
      slotProps={{ container: { ref: containerRef, onScroll } }}
      features={{
        table: { stickyHeader: true },
        tanstackOptions: {
          data,
          columns,
          getRowId: (row) => row.productId.toString(),
          state: { isLoading: isFetching },
        },
      }}
      noDataMessage='No quoted products found for this customer.'
    />
  )
}
